export interface Article {
  id: string;
  title: string;
  author: string;
  date: string;
  category: string;
  image: string;
  url: string;
}

export const featuredArticles: Article[] = [
  {
    id: "1",
    title: "13 Things to Look for When Buying Your First Home",
    author: "Justin Reynolds",
    date: "September 4, 2025",
    category: "Aspiring Home Buyers",
    image: "/blog/13-things-buying-first-home.jpg",
    url: "/blog/13-things-to-look-for-when-buying-your-first-home",
  },
  {
    id: "2",
    title: "House Hacking: Live in One Unit, Rent Out the Other",
    author: "Justin Reynolds",
    date: "November 18, 2025",
    category: "Real Estate Investing",
    image: "/blog/house-hacking-investing.jpg",
    url: "/blog/real-estate-investing-live-in-one-unit-rent-out-the-other",
  },
  {
    id: "3",
    title: "Top Home Security Tips for Families",
    author: "Justin Reynolds",
    date: "November 11, 2025",
    category: "Current Homeowners",
    image: "/blog/home-security-tech-hero.jpg",
    url: "/blog/technology-for-home-security",
  },
  {
    id: "4",
    title: "The True Cost of Owning a Home (Beyond the Mortgage)",
    author: "Justin Reynolds",
    date: "November 6, 2025",
    category: "First-Time Homeowners",
    image: "/blog/true-cost-homeownership.jpg",
    url: "/blog/the-true-cost-of-owning-a-home-beyond-the-mortgage",
  },
];

export const popularArticles: Article[] = [
  {
    id: "p1",
    title: "Spring Home Checklist: Top Tips",
    author: "Justin Reynolds",
    date: "",
    category: "Current Homeowners",
    image: "/blog/spring-home-checklist.jpg",
    url: "/blog/spring-home-checklist-top-tips",
  },
  {
    id: "p2",
    title: "Pest Control for Homes",
    author: "Justin Reynolds",
    date: "",
    category: "Current Homeowners",
    image: "/blog/pest-control-for-homes.jpg",
    url: "/blog/pest-control-for-homes",
  },
  {
    id: "p3",
    title: "When to Repair or Replace Appliances",
    author: "Justin Reynolds",
    date: "",
    category: "Current Homeowners",
    image: "/blog/when-to-repair-replace-appliances.jpg",
    url: "/blog/home-maintenance-when-to-repair-replace-appliances",
  },
  {
    id: "p4",
    title: "10 Budget-Friendly Home Improvement Ideas That Instantly Upgrade Your Space",
    author: "Justin Reynolds",
    date: "",
    category: "DIY & Home Improvement",
    image: "/blog/budget-home-improvement-ideas.jpg",
    url: "/blog/budget-home-improvement-ideas",
  },
];

export const mustReadArticles: Article[] = [
  {
    id: "m1",
    title: "$10,000 Grant for Home Improvement",
    author: "Justin Reynolds",
    date: "",
    category: "Financial Wellness",
    image: "/blog/10k-grant-home-improvement.jpg",
    url: "/blog/how-to-get-a-10k-grant-for-home-improvement",
  },
  {
    id: "m2",
    title: "HELOC: Everything You Need to Know About Home Equity Lines of Credit",
    author: "Justin Reynolds",
    date: "",
    category: "Financial Wellness",
    image: "/blog/heloc-guide.jpg",
    url: "/blog/heloc-guide-everything-you-need-to-know-about-home-equity-lines-of-credit",
  },
  {
    id: "m3",
    title: "7 Tips on How to Buy With No Money",
    author: "Justin Reynolds",
    date: "",
    category: "Aspiring Home Buyers",
    image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=760&h=428&fl=progressive&q=90&fm=jpg",
    url: "/blog/7-tips-on-how-to-buy-with-no-money",
  },
  {
    id: "m4",
    title: "How to Get a Home Equity Loan With Bad Credit",
    author: "Justin Reynolds",
    date: "",
    category: "Financial Wellness",
    image: "/blog/home-equity-loan-bad-credit.jpg",
    url: "/blog/how-to-get-a-home-equity-loan-with-bad-credit",
  },
];

export const latestPosts: Article[] = [
  {
    id: "l10",
    title: "The Ultimate First-Time Homebuyer Checklist (2026 Edition)",
    author: "Justin Reynolds",
    date: "April 3, 2026",
    category: "Aspiring Home Buyers",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=760&h=428&fit=crop&q=80",
    url: "/blog/ultimate-first-time-homebuyer-checklist-2026",
  },
  {
    id: "l9",
    title: "ADUs & Guest Suites: How Extra Space Is Becoming 2026's Hottest Asset",
    author: "Justin Reynolds",
    date: "March 25, 2026",
    category: "DIY & Home Improvement",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=760&h=428&fit=crop&q=80",
    url: "/blog/adus-and-guest-suites-hottest-asset-2026",
  },
  {
    id: "l1",
    title: "Is a Backyard Shed Worth It? Storage, Studio, and Office Uses",
    author: "Justin Reynolds",
    date: "October 24, 2025",
    category: "DIY & Home Improvement",
    image: "/blog/home-improvement-backyard-shed.jpg",
    url: "/blog/home-improvement-backyard-shed",
  },
  {
    id: "l2",
    title: "Installing a Hot Tub: What You Need to Know About Setup, Safety, and Maintenance",
    author: "Justin Reynolds",
    date: "October 29, 2025",
    category: "DIY & Home Improvement",
    image: "/blog/hot-tub-hero.jpg",
    url: "/blog/home-improvement-installing-a-hot-tub",
  },
  {
    id: "l3",
    title: "Building a Detached Garage: Cost, Permits, and Design Tips",
    author: "Justin Reynolds",
    date: "November 20, 2025",
    category: "DIY & Home Improvement",
    image: "/blog/detached-garage-hero.jpg",
    url: "/blog/home-improvement-building-a-detached-garage",
  },
  {
    id: "l4",
    title: "Outdoor Living Spaces",
    author: "Justin Reynolds",
    date: "November 4, 2025",
    category: "Gardening & Outdoor Living",
    image: "/blog/outdoor-living-spaces.jpg",
    url: "/blog/outdoor-living-spaces",
  },
  {
    id: "l5",
    title: "Best Home Office Setup: Interior Design Tips",
    author: "Justin Reynolds",
    date: "October 28, 2025",
    category: "Interior Design",
    image: "/blog/best-home-office-setup.jpg",
    url: "/blog/best-home-office-setup-interior-design",
  },
  {
    id: "l6",
    title: "Interior Design: Open Floor Plans",
    author: "Justin Reynolds",
    date: "November 21, 2025",
    category: "Interior Design",
    image: "/blog/small-home-larger-modern-living.jpg",
    url: "/blog/interior-design-open-floor-plans",
  },
  {
    id: "l7",
    title: "9 Most Common Home Repairs and Their Costs",
    author: "Justin Reynolds",
    date: "October 30, 2025",
    category: "Current Homeowners",
    image: "/blog/home-repairs-hero.jpg",
    url: "/blog/9-most-common-home-repairs-and-their-costs",
  },
  {
    id: "l8",
    title: "DIY Project: Storage Solutions for Small Spaces",
    author: "Justin Reynolds",
    date: "November 17, 2025",
    category: "DIY & Home Improvement",
    image: "/blog/diy-storage-hero.jpg",
    url: "/blog/diy-project-storage-solutions-for-small-spaces",
  },
];

export const categories = [
  { name: "Aspiring Home Buyers", url: "/blog?category=Aspiring+Home+Buyers" },
  { name: "Current Homeowners", url: "/blog?category=Current+Homeowners" },
  { name: "DIY & Home Improvement", url: "/blog?category=DIY+%26+Home+Improvement" },
  { name: "Financial Wellness", url: "/blog?category=Financial+Wellness" },
  { name: "First-Time Homeowners", url: "/blog?category=First-Time+Homeowners" },
  { name: "Gardening & Outdoor Living", url: "/blog?category=Gardening+%26+Outdoor+Living" },
  { name: "Interior Design", url: "/blog?category=Interior+Design" },
  { name: "Real Estate Investing", url: "/blog?category=Real+Estate+Investing" },
  { name: "Home Sellers", url: "/blog?category=Home+Sellers" },
];
